import React from "react";
import { getAwsAssets } from "@src/utils";
import styles from "../../../styles/DownloadProgressIcon.module.scss";
import { Image } from "@src/components/Image";

const DownloadProgressIcon = ({
  progress = 0,
  onClick = null,
  withoutIcon = null,
  startAngle = 0,
}) => {
  // HANDLE ICON CLICKED
  const handleIconClicked = (e) => {
    e.stopPropagation();
    onClick && onClick();
  };

  return (
    <div className={styles.downloadProgressIcon}>
      <div
        className={styles.downloadProgressIcon__icon}
        onClick={handleIconClicked}
        style={{
          "--progressDeg": `${(parseInt(progress) || 0) * 3.6}deg`,
          ...(startAngle ? { transform: `rotate(${startAngle}deg)` } : {}),
        }}
      >
        <div className={styles.downloadProgressIcon__icon__content}>
          {!withoutIcon && (
            <Image
              src={getAwsAssets("crossIcon.svg", "content")}
              alt="crossIcon"
              height={12}
              width={12}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadProgressIcon;
